import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import ModalBox from '../../../shared/modal';

import classname from 'classname';

lessRequire('modules/offers/components/popups/rules.less');

const DownloadPopup = props => {
	const className = classname({
		'ReactModal__Content': true,
		'ReactModal__Content--after-open': true,
		'modal-overlay__content': true,
		'rules-modal': true
	});

	return (
		<ModalBox
			body={ModalBody(props)}
			isOpen={props.isOpen}
			onClose={props.togglePopup}
			title={`${props.intl('Введите ссылку на лендинг')}`}
			className={className}
		/>
	);
};

DownloadPopup.propTypes = {
	shouldShowRules: PropTypes.bool,
	selectedOffer: PropTypes.object,
	toggleRulesPopup: PropTypes.func,
	intl: PropTypes.func
};

const ModalBody = (props) => {
	const message = props.intl('(можно оставить поле пустым, но тогда потребуется отредактировать ссылки для перехода на лендинг вручную)'); // eslint-disable-line max-len
	const isAdditionalMessageVisible = !props.is_php && process.env.CPA_ENV === 'everad';

	function openHref() {
		props.closePopup();
		window.open(props.is_php ? `${props.href}&is_php=true` : props.href, '_blank');
	}
	function openChangedHref(isPhp) {
		props.closePopup();
		window.open(isPhp ? `${props.href}&is_php=true` : props.href, '_blank');
	}

	return (
		<div className="rules-body transit-rules">
			<div className="rule-wrap">
				{message}
			</div>
			{
				isAdditionalMessageVisible &&
				<div className="rule-wrap red-text">
					{props.intl('Для работы потока по API необходимо качать архив в php')}!!!
				</div>
			}
			<div className="form-element active">
				<input
					id="transit_link"
					autoFocus="true"
					placeholder={props.intl('любой URL или его часть')}
					onChange={e => {
						props.setTransitLinkUrl(e.target.value);
					}}
					type="text" form="streamForm"
					className="form-element__control font-proxima-nova-regular"
				/>
			</div>
			{
				!isAdditionalMessageVisible &&
				<div className="control-btn">
					<input
						id={'join_offer'}
						type="button" form="streamForm"
						className="button yellow-btn font-proxima-nova-semibold"
						onClick={openHref}
						value={props.intl('OK')}
					/>
				</div>
			}
			{
				isAdditionalMessageVisible &&
					<div className="control-btn display-flex-between">
						<input
							id={'join_offer'}
							type="button" form="streamForm"
							className="button yellow-btn font-proxima-nova-semibold"
							onClick={openChangedHref.bind(null, true)}
							value={props.intl('Сохранить в php')}
						/>
						<input
							id={'join_offer'}
							type="button" form="streamForm"
							className="button font-proxima-nova-semibold"
							onClick={openChangedHref.bind(null, false)}
							value={props.intl('Сохранить в html')}
						/>
					</div>
			}
		</div>
	);
};

ModalBody.propTypes = {
	intl: PropTypes.func,
	href: PropTypes.string,
	selectedOffer: PropTypes.object
};

export default DownloadPopup;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/popups/transit-link-popup.js